export interface IntrospectionResultData {
  __schema: {
    types: {
      kind: string;
      name: string;
      possibleTypes: {
        name: string;
      }[];
    }[];
  };
}
const result: IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: 'INTERFACE',
        name: 'Paginatable',
        possibleTypes: [
          {
            name: 'AbsenceReasonCollection',
          },
          {
            name: 'AbsenceCollection',
          },
          {
            name: 'EmploymentCollection',
          },
          {
            name: 'AssignmentGroupCollection',
          },
          {
            name: 'AvailabilityCollection',
          },
          {
            name: 'AvailabilityAggregationCollection',
          },
          {
            name: 'AvailabilityExceptionCollection',
          },
          {
            name: 'BackgroundJobCollection',
          },
          {
            name: 'ChatEmploymentCollection',
          },
          {
            name: 'ChatMessageCollection',
          },
          {
            name: 'ChatCollection',
          },
          {
            name: 'CompanyCollection',
          },
          {
            name: 'CustomFieldCollection',
          },
          {
            name: 'DayNoteCollection',
          },
          {
            name: 'PaymentCollection',
          },
          {
            name: 'EmploymentsPositionCollection',
          },
          {
            name: 'EmploymentsRotationGroupsCollection',
          },
          {
            name: 'EvaluationBreakCollection',
          },
          {
            name: 'EvaluationCollection',
          },
          {
            name: 'IndividualShiftRotationCollection',
          },
          {
            name: 'LanguageCollection',
          },
          {
            name: 'LiveStaffShiftCollection',
          },
          {
            name: 'LocationCollection',
          },
          {
            name: 'LocationsPositionCollection',
          },
          {
            name: 'NewsfeedCollection',
          },
          {
            name: 'NotificationConfigurationCollection',
          },
          {
            name: 'PaygradeTypeCollection',
          },
          {
            name: 'PayslipCollection',
          },
          {
            name: 'PositionCollection',
          },
          {
            name: 'QualificationCollection',
          },
          {
            name: 'RightCollection',
          },
          {
            name: 'ShiftAssignmentGroupCollection',
          },
          {
            name: 'ShiftAvailableEmploymentCollection',
          },
          {
            name: 'ShiftBreakCollection',
          },
          {
            name: 'TagCollection',
          },
          {
            name: 'ShiftPaygradeCollection',
          },
          {
            name: 'ShiftplanCollection',
          },
          {
            name: 'ShiftPresetCollection',
          },
          {
            name: 'ShiftRotationGroupCollection',
          },
          {
            name: 'ShiftRotationCollection',
          },
          {
            name: 'ShiftCollection',
          },
          {
            name: 'ShiftsTagCollection',
          },
          {
            name: 'SpecialDateCollection',
          },
          {
            name: 'StaffShiftCollection',
          },
          {
            name: 'StaffShiftsTagCollection',
          },
          {
            name: 'UserCollection',
          },
          {
            name: 'EmploymentsSurveyCollection',
          },
          {
            name: 'EmploymentEvaluationCollection',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Identifiable',
        possibleTypes: [
          {
            name: 'AbsenceReason',
          },
          {
            name: 'Company',
          },
          {
            name: 'Location',
          },
          {
            name: 'Position',
          },
          {
            name: 'Newsfeed',
          },
          {
            name: 'Employment',
          },
          {
            name: 'EmploymentWorkHour',
          },
          {
            name: 'PunchTiming',
          },
          {
            name: 'StaffShift',
          },
          {
            name: 'Shift',
          },
          {
            name: 'Request',
          },
          {
            name: 'LocationsPosition',
          },
          {
            name: 'Shiftplan',
          },
          {
            name: 'Payment',
          },
          {
            name: 'PaygradeType',
          },
          {
            name: 'EvaluationBreak',
          },
          {
            name: 'StaffShiftsTag',
          },
          {
            name: 'Tag',
          },
          {
            name: 'ShiftAssignmentGroup',
          },
          {
            name: 'AssignmentGroup',
          },
          {
            name: 'ShiftPreset',
          },
          {
            name: 'ShiftRotationGroup',
          },
          {
            name: 'ShiftRotation',
          },
          {
            name: 'EmploymentsRotationGroup',
          },
          {
            name: 'Paygrade',
          },
          {
            name: 'ShiftBreak',
          },
          {
            name: 'Qualification',
          },
          {
            name: 'PunchBreak',
          },
          {
            name: 'Language',
          },
          {
            name: 'User',
          },
          {
            name: 'Absence',
          },
          {
            name: 'Availability',
          },
          {
            name: 'AvailabilityException',
          },
          {
            name: 'ChatEmployment',
          },
          {
            name: 'ChatMessage',
          },
          {
            name: 'ChatMessageEmployment',
          },
          {
            name: 'ChatLocation',
          },
          {
            name: 'ChatLocationsPosition',
          },
          {
            name: 'CustomField',
          },
          {
            name: 'DayNote',
          },
          {
            name: 'EmploymentEvaluation',
          },
          {
            name: 'EmploymentEvaluationTag',
          },
          {
            name: 'EmploymentsPosition',
          },
          {
            name: 'IndividualShiftRotation',
          },
          {
            name: 'EmploymentsSurvey',
          },
          {
            name: 'EmploymentsUiSetting',
          },
          {
            name: 'LiveStaffShift',
          },
          {
            name: 'Payslip',
          },
          {
            name: 'PunchingLocationsPosition',
          },
          {
            name: 'ShiftAvailableEmployment',
          },
          {
            name: 'ShiftPaygrade',
          },
          {
            name: 'ShiftsTag',
          },
          {
            name: 'SpecialDate',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Timestampable',
        possibleTypes: [
          {
            name: 'AbsenceReason',
          },
          {
            name: 'Company',
          },
          {
            name: 'Location',
          },
          {
            name: 'Position',
          },
          {
            name: 'Newsfeed',
          },
          {
            name: 'Employment',
          },
          {
            name: 'EmploymentWorkHour',
          },
          {
            name: 'PunchTiming',
          },
          {
            name: 'StaffShift',
          },
          {
            name: 'Shift',
          },
          {
            name: 'Request',
          },
          {
            name: 'Evaluation',
          },
          {
            name: 'LocationsPosition',
          },
          {
            name: 'Shiftplan',
          },
          {
            name: 'PaygradeType',
          },
          {
            name: 'EvaluationBreak',
          },
          {
            name: 'StaffShiftsTag',
          },
          {
            name: 'ShiftAssignmentGroup',
          },
          {
            name: 'AssignmentGroup',
          },
          {
            name: 'ShiftPreset',
          },
          {
            name: 'ShiftRotationGroup',
          },
          {
            name: 'ShiftRotation',
          },
          {
            name: 'Qualification',
          },
          {
            name: 'User',
          },
          {
            name: 'Absence',
          },
          {
            name: 'Availability',
          },
          {
            name: 'AvailabilityException',
          },
          {
            name: 'BackgroundJob',
          },
          {
            name: 'EmploymentEvaluationTag',
          },
          {
            name: 'IndividualShiftRotation',
          },
          {
            name: 'PunchingLocationsPosition',
          },
          {
            name: 'ShiftsTag',
          },
          {
            name: 'SpecialDate',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Timeframeable',
        possibleTypes: [
          {
            name: 'Shift',
          },
          {
            name: 'Shiftplan',
          },
          {
            name: 'Absence',
          },
          {
            name: 'Availability',
          },
          {
            name: 'AvailabilityException',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'ChatUser',
        possibleTypes: [
          {
            name: 'ChatMessageEmployment',
          },
          {
            name: 'ChatLocation',
          },
          {
            name: 'ChatLocationsPosition',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'RotationGroupUnion',
        possibleTypes: [
          {
            name: 'EmploymentsRotationGroup',
          },
          {
            name: 'IndividualShiftRotation',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'PunchStateOrError',
        possibleTypes: [
          {
            name: 'PunchState',
          },
          {
            name: 'PunchError',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'ShiftConflict',
        possibleTypes: [
          {
            name: 'ShiftsCollisionShiftConflict',
          },
          {
            name: 'AbsencesCollisionShiftConflict',
          },
          {
            name: 'AlreadyAssignedShiftConflict',
          },
          {
            name: 'MaximumWorkingHoursShiftConflict',
          },
          {
            name: 'MaximumEarningShiftConflict',
          },
          {
            name: 'MinimumRestShiftConflict',
          },
          {
            name: 'OutsideWorkPeriodShiftConflict',
          },
          {
            name: 'MaximumConsecutiveWorkingDaysShiftConflict',
          },
          {
            name: 'RestrictedShiftPresetsConflict',
          },
          {
            name: 'UnknownShiftConflict',
          },
          {
            name: 'MinimumBreakShiftConflict',
          },
          {
            name: 'LocationsPositionChangedShiftConflict',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'AbsenceCreateResult',
        possibleTypes: [
          {
            name: 'Absence',
          },
          {
            name: 'ConflictsResponse',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'Conflict',
        possibleTypes: [
          {
            name: 'CollisionsConflict',
          },
          {
            name: 'MaxDaysPerYearConflict',
          },
          {
            name: 'CarryOverDeadlineErrorConflict',
          },
          {
            name: 'CarryOverMultipleYearsConflict',
          },
          {
            name: 'UnknownConflict',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'AbsenceApproveResult',
        possibleTypes: [
          {
            name: 'CreateResponse',
          },
          {
            name: 'ConflictsResponse',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'AvailabilityCreateResult',
        possibleTypes: [
          {
            name: 'Availability',
          },
          {
            name: 'AvailabilityConflictResponse',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'CreatePunchingShiftConflict',
        possibleTypes: [
          {
            name: 'WarningStaffOverpaid',
          },
          {
            name: 'ErrorStaffOverpaid',
          },
          {
            name: 'WarningRestPeriodBelowMinimum',
          },
          {
            name: 'ErrorRestPeriodBelowMinimum',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'CreatePunchingShiftConflictWithStringValue',
        possibleTypes: [
          {
            name: 'ErrorStaffOverpaid',
          },
          {
            name: 'ErrorRestPeriodBelowMinimum',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'CreatePunchingShiftConflictWithIntValue',
        possibleTypes: [
          {
            name: 'WarningRestPeriodBelowMinimum',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'AcceptReplaceRequestResult',
        possibleTypes: [
          {
            name: 'PendingReplaceRequest',
          },
          {
            name: 'RequestState',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'ConfirmReplaceRequestResult',
        possibleTypes: [
          {
            name: 'PendingReplaceRequest',
          },
          {
            name: 'RequestState',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'ShiftCreateResult',
        possibleTypes: [
          {
            name: 'Shift',
          },
          {
            name: 'ShiftConflictsResponse',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'StaffShiftCreateResult',
        possibleTypes: [
          {
            name: 'StaffShift',
          },
          {
            name: 'ShiftConflictsResponse',
          },
        ],
      },
    ],
  },
};
export default result;
